import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, Dropdown } from 'reactstrap';
import Avatar from '../common/Avatar';
import AppContext from '../../context/Context';

const ProfileDropdown = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { currentUserPic, toggleModal, currentUser } = useContext(AppContext);
  const isAdmin = currentUser?.roles?.includes('customer-account-admin');
  const toggle = () => setDropdownOpen(prevState => !prevState);
  return (
    <Dropdown
      nav
      inNavbar
      isOpen={dropdownOpen}
      toggle={toggle}
      onMouseOver={() => {
        let windowWidth = window.innerWidth;
        windowWidth > 992 && setDropdownOpen(true);
      }}
      onMouseLeave={() => {
        let windowWidth = window.innerWidth;
        windowWidth > 992 && setDropdownOpen(false);
      }}
    >
      <DropdownToggle nav className="pr-0">
        <Avatar src={currentUserPic} />
      </DropdownToggle>
      <DropdownMenu right className="dropdown-menu-card">
        <div className="bg-white rounded-soft py-2">
          <DropdownItem tag={Link} to="/pages/profile">
            Konto
          </DropdownItem>
          <DropdownItem tag={Link} to="/pages/notificationsContentSelector">
            Benachrichtigungen
          </DropdownItem>
          {isAdmin && (
            <DropdownItem tag={Link} to="/pages/companyContext">
              Unternehmenskontext
            </DropdownItem>
          )}
          <DropdownItem onClick={() => toggleModal()}>
            Einstellungen
          </DropdownItem>
          <DropdownItem tag={Link} to="/authentication/basic/logout">
            Abmelden
          </DropdownItem>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ProfileDropdown;
